import SubscriptionCancelDialog from './SubscriptionCancelDialog';

export default SubscriptionCancelDialog;
